import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Container } from '../../layout/Container'
import { Card } from '../../ui/Card'
import { Brain, Wrench, ShieldCheck, ArrowRight } from 'lucide-react'

const modules = [
  { key: 'brain', href: '/plataforma/brain', icon: Brain },
  { key: 'build', href: '/plataforma/build', icon: Wrench },
  { key: 'govern', href: '/plataforma/govern', icon: ShieldCheck },
]

export function HowWeWorkContinue() {
  const { t } = useTranslation()

  return (
    <section className="border-t border-border bg-surface py-24">
      <Container size="wide">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t('howWeWorkPage.continue.label')}
          </span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
            {t('howWeWorkPage.continue.title')}
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-4 sm:grid-cols-3">
          {modules.map((module, index) => {
            const Icon = module.icon
            return (
              <motion.div
                key={module.key}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <Link to={module.href}>
                  <Card variant="elevated" hover className="group h-full">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent/10 text-accent-light transition-colors group-hover:bg-accent group-hover:text-white">
                          <Icon className="h-5 w-5" />
                        </div>
                        <div>
                          <p className="font-medium text-text-primary">{t(`header.${module.key}`)}</p>
                          <p className="text-sm text-text-secondary">
                            {t(`platformPages.${module.key}.shortDescription`)}
                          </p>
                        </div>
                      </div>
                      <ArrowRight className="h-5 w-5 text-text-secondary transition-transform group-hover:translate-x-1 group-hover:text-accent-light" />
                    </div>
                  </Card>
                </Link>
              </motion.div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
